import { useState, useEffect } from 'react';
import { BsPlusCircleFill, BsPlus } from 'react-icons/bs';
import { DotsVerticalIcon } from '@heroicons/react/solid';
import { useEffectCancelled } from '@wajeez-web/components/helpers';
import {
  Button,
  CallBackSelector,
  DropDown,
  InnerPageToggleButton,
  TextAreaInput,
} from '@wajeez-web/components/ui';
import WajeezList from './WajeezList';

export interface AddActions<TItem> {
  type: 'page' | 'modal' | 'search' | 'input';
  getRoute?: () => string;
  place?: 'top' | 'withList';
  contentType?: 'list' | 'form';
  searchAction?: (element: string) => Promise<void>;
  placeholder?: string;
  name?: string;
  addItem?: (newadd: string) => void;
  formextras?: {
    // formProps: FormBuilderProps;
  };
}

export type ListBuilderProps<TItem> = {
  title?: string;
  desc?: string;
  isLoading?: boolean;
  orderAction?: (data: TItem[]) => void;
  showAs?: 'rows' | 'cards';
  gridItems?: number;
  addAction?: AddActions<TItem>[];
  getData?: (canceller: AbortController) => void | Promise<void>;
  data: TItem[];
  renderItem: (item: TItem, index: number) => JSX.Element;
  keyExtractor: (item: TItem, index: number) => string;
  hasToggelButton?: boolean;
};

function ListBuilder<TItem>({
  title,
  desc,
  showAs,
  addAction,
  getData,
  data,
  renderItem,
  hasToggelButton,
  isLoading,
  keyExtractor,
  gridItems = 5,
  orderAction,
}: ListBuilderProps<TItem>) {
  const [newadd, setNewAdd] = useState('');
  const [searchInputList, setSearchInputList] = useState<
    { label: string; value: string }[]
  >([]);
  const [isOrdering, setIsOrdering] = useState(false);
  const [orderingList, setOrderingList] = useState(data);
  const [orderLoder, setOrderLoader] = useState(false);
  useEffectCancelled((canceller: AbortController) => {
    getData && getData(canceller);
    setNewAdd('');
    setSearchInputList([]);
  }, []);

  useEffect(() => {
    setNewAdd('');
    setSearchInputList([]);
    setOrderingList(data);
    setIsOrdering(false);
    setOrderLoader(false);
  }, [data]);

  const getaddComponent = (addAction: AddActions<TItem> | undefined) => {
    if (addAction) {
      const { type, placeholder, name, searchAction, addItem } = addAction;
      if (isOrdering) {
        return null;
      }
      switch (type) {
        case 'input':
          return (
            <TextAreaInput
              rows={1}
              placeholder={placeholder}
              label={name}
              value={newadd}
              name={'name'}
              onChange={(name, val) => setNewAdd(val)}
              size="med"
              suffix={
                <button
                  onClick={() => addItem && addItem(newadd)}
                  className="rounded-full bg-transparent hover:bg-gray-500 hover:bg-gray-500/10 p-2 text-textSecondary text-center"
                >
                  <BsPlusCircleFill className="h-4 w-4" />
                </button>
              }
            />
          );
        case 'search':
          return (
            <div className="flex space-s-2  align-middle">
              <div className="w-full">
                <CallBackSelector
                  key={title}
                  value={
                    searchInputList.find((ele) => ele.value === newadd) ||
                    undefined
                  }
                  onSearch={searchAction}
                  onChange={(name, value: any) => setNewAdd(value.value)}
                  name={'searchElement'}
                />
              </div>
              <button
                onClick={() => addItem && addItem(newadd)}
                className="rounded-full bg-transparent  hover:bg-gray-500/10 p-2 text-textSecondary text-center"
              >
                <BsPlusCircleFill className="h-4 w-4" />
              </button>
            </div>
          );
        default:
          return (
            <Button
              bg="primary"
              color="white"
              title={'Add new'}
              Icon={BsPlus}
              onClick={() => addItem && addItem('')}
            />
          );
      }
    }
    return undefined;
  };

  // const getRowActions = (
  //   { type, showAs, getRoute }: RowsActions<TItem>,
  //   i: number
  // ) => {
  //   switch (type) {
  //     case 'delete':
  //       return (
  //         <button
  //           key={'delete'}
  //           onClick={() => onDelete && onDelete(i)}
  //           className="rounded-full w-auto bg-transparent  hover:bg-gray-500/10 p-2 text-textSecondary text-center"
  //         >
  //           <RiDeleteBinLine className="h-5 w-5" />
  //         </button>
  //       );
  //     case 'edit':
  //       return showAs === 'page' ? (
  //         <Link to={(getRoute && getRoute(data[i])) ?? '/#'}>
  //           <button
  //             key={'edit'}
  //             onClick={() => editRow && editRow(i)}
  //             className="rounded-full bg-transparent  hover:bg-gray-500/10 p-2 text-textSecondary text-center"
  //           >
  //             <BiEditAlt className="h-5 w-5" />
  //           </button>
  //         </Link>
  //       ) : (
  //         <button
  //           key={'edit'}
  //           onClick={() => editRow && editRow(i)}
  //           className="rounded-full bg-transparent  hover:bg-gray-500/10 p-2 text-textSecondary text-center"
  //         >
  //           <BiEditAlt className="h-5 w-5" />
  //         </button>
  //       );
  //     case 'assign':
  //       return (
  //         <button
  //           key={'assign'}
  //           onClick={() => onAssign && onAssign(i)}
  //           className="rounded-full bg-transparent  hover:bg-gray-500/10 p-2 text-textSecondary text-center"
  //         >
  //           <BiAddToQueue className="h-5 w-5" />
  //         </button>
  //       );
  //     default:
  //       return <div></div>;
  //   }
  // };

  // const getList = () => {
  //   switch (showAs) {
  //     case 'rows':
  //       return isOrdering ? (
  //         <Sortable
  //           data={orderingList}
  //           setData={(items: TItem[]) => setOrderingList(items)}
  //           keyExtractor={keyExtractor}
  //           renderItem={(item: TItem, i: number) => (
  //             // TODO: Add Proper UI
  //             <div
  //               key={i}
  //               className="flex items-center justify-between space-x-2"
  //             ></div>
  //           )}
  //         />
  //       ) : (
  //         <div className="divide-y border-b border-t">
  //           {data?.map((item, index) => (
  //             <div
  //               key={keyExtractor(item, index)}
  //               className="justify-between  space-s-4 flex py-6 align-middle"
  //             >
  //               <div className="text-textPrimary my-auto">
  //                 {mapItem(item, index).name}
  //               </div>
  //               <div className="flex space-s-1 h-full align-middle">
  //                 {rowActions.map((item, i) => (
  //                   <HasPermissionWrapperComponent
  //                     key={item.type + i}
  //                     permissions={item.permission}
  //                   >
  //                     {getRowActions(item, index)}
  //                   </HasPermissionWrapperComponent>
  //                 ))}
  //               </div>
  //             </div>
  //           ))}
  //         </div>
  //       );
  //     case 'cards': {
  //       const ele = addAction?.find((ele) => ele.place === 'withList');
  //       return (
  //         <div
  //           className={`grid sm:grid-cols-${
  //             gridItems - 3 < 1 ? 1 : gridItems - 3
  //           }md:grid-cols-${gridItems - 2} lg:grid-cols-${
  //             gridItems - 1
  //           } xl:grid-cols-${gridItems} gap-5 `}
  //         >
  //           {!!ele && (
  //             <div className=" text-center border justify-center align-middle h-full border-dashed border-gray-400 hover:bg-gray-200">
  //               <Link
  //                 className="h-full w-full flex justify-center align-middle"
  //                 to={(ele?.getRoute && ele.getRoute()) || ''}
  //               >
  //                 <AiOutlinePlus className="m-auto text-4xl font-extrabold text-gray-400" />
  //               </Link>
  //             </div>
  //           )}
  //           {data?.map((item, index) => {
  //             const mapped = mapItem(item, index);

  //             return (
  //               <Card key={index}>
  //                 <div className=" space-y-3 w-full ">
  //                   <div className="flex justify-between">
  //                     {mapped.name && (
  //                       <div className="flex items-center bg-ring-color py-1 px-3 w-auto rounded-full text-xs truncate me-1">
  //                         <div className="truncate">{mapped.name}</div>
  //                       </div>
  //                     )}
  //                     {headerExtraComponent &&
  //                       headerExtraComponent(item, index)}
  //                   </div>
  //                   <div className="justify-between">
  //                     <div>
  //                       <div className="text-textPrimary font-semibold text-xl truncate">
  //                         {mapped.title}
  //                       </div>
  //                       <div className="w-fit inline-block text-sm text-textSecondary">
  //                         {mapped.desc}
  //                       </div>
  //                     </div>
  //                     <div></div>
  //                     {extraActions && extraActions(item, index)}
  //                   </div>
  //                 </div>
  //               </Card>
  //             );
  //           })}
  //         </div>
  //       );
  //     }

  //     default:
  //       return undefined;
  //   }
  // };

  return (
    <div className="py-2 h-full w-full flex-col flex space-y-2">
      {(title || addAction?.find((ele) => ele.place === 'top')) && (
        <div className="">
          <div className="flex justify-between">
            <h3 className="ms-2 lg:ms-0  text-2xl font-bold tracking-tight leading-none flex ">
              {hasToggelButton && <InnerPageToggleButton />}{' '}
              <div className="mt-1">{title}</div>
            </h3>
            <div className="flex space-s-2">
              {orderAction && isOrdering ? (
                <>
                  <Button
                    color="textPrimary"
                    bg="gray-500"
                    title={'Cancel'}
                    onClick={() => {
                      setIsOrdering(false);
                    }}
                  />
                  <Button
                    loading={orderLoder}
                    title={'Save changes'}
                    onClick={() => {
                      setIsOrdering(true);
                      orderAction(orderingList);
                    }}
                  />
                </>
              ) : orderAction ? (
                <DropDown
                  name="extra"
                  Icon={DotsVerticalIcon}
                  list={[
                    {
                      label: 'order',
                      onClick: () => setIsOrdering(true),
                      type: 'action',
                    },
                  ]}
                />
              ) : null}
              {addAction?.find((ele) => ele.place === 'top')
                ? getaddComponent(addAction.find((ele) => ele.place === 'top'))
                : null}
            </div>
          </div>
          <p className=" text-sm text-gray-600">{desc}</p>
        </div>
      )}
      <div className="">
        {addAction &&
          addAction.find(
            (ele) =>
              (ele.type == 'input' || ele.type === 'search') &&
              ele.place !== 'withList'
          ) &&
          getaddComponent(
            addAction.find(
              (ele) =>
                (ele.type == 'input' || ele.type === 'search') &&
                ele.place !== 'withList'
            )
          )}
      </div>

      <WajeezList
        data={data}
        keyExtractor={keyExtractor}
        renderItem={renderItem}
        containerType={showAs}
        getData={getData}
        gridItems={gridItems}
        isLoading={isLoading}
      />
    </div>
  );
}

export default ListBuilder;
